"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapData = void 0;
var contentSize_1 = require("./contentSize");
var filtering_1 = require("./filtering");
var sorting_1 = require("./sorting");
var mapData = function (data) {
    var initData = { items: [], columns: data.columns };
    var keys = Object.keys(data.columns);
    var filterAndCalculate = function (acc, item) {
        acc.columns = (0, contentSize_1.calculateColumns)(acc.columns, keys, item);
        if ((0, filtering_1.filterItem)(acc.columns, keys, item, data.filterOptions)) {
            acc.items.push(item);
        }
        return acc;
    };
    var _a = data.items.reduce(filterAndCalculate, initData), items = _a.items, columns = _a.columns;
    items.sort((0, sorting_1.sortItems)(data));
    return {
        contentWidth: (0, contentSize_1.getContentWidth)(columns),
        columns: columns,
        items: items
    };
};
exports.mapData = mapData;
